import { Query } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { WorkInfoState, WorkInfoStore } from './work-info.store';

@Injectable({
  providedIn: 'root',
})
export class WorkInfoQuery extends Query<WorkInfoState> {
  workInfo$ = this.select((state) => state?.workInfo);
  workInfoOrder$ = this.select((state) => state.workInfo?.order);
  workInfoOrderTime$ = this.select((state) => state.workInfo?.order?.time);
  workInfoOrderSelectable$ = this.select(
    (state) => state.workInfo?.order?.selectable
  );
  workInfoOrderValue$ = this.select((state) => state.workInfo?.order?.order?.orderID
      ? state.workInfo?.order?.order?.orderNumber +
          ' - ' +
          state.workInfo?.order?.order?.orderName
      : '');

  workInfoOperation$ = this.select((state) => state.workInfo?.operation);
  workInfoOperationTime$ = this.select(
    (state) => state.workInfo?.operation?.time
  );
  workInfoOperationSelectable$ = this.select(
    (state) => state.workInfo?.operation?.state
  );
  workInfoOperationValue$ = this.select((state) => {
    if (
      state.workInfo?.operation?.operation?.aksPlanID &&
      state.workInfo?.operation?.operation?.aksPlanID !== 0
    ) {
      return (
        state.workInfo?.operation?.operation?.operation +
        ' - ' +
        state.workInfo?.operation?.operation?.note
      );
    } else {
      return state.workInfo?.operation?.text;
    }
  });

  workInfoCostCenter$ = this.select((state) => state.workInfo?.costCenter);
  workInfoCostCenterTime$ = this.select(
    (state) => state.workInfo?.costCenter?.time
  );
  workInfoCostCenterSelectable$ = this.select(
    (state) => state.workInfo?.costCenter?.selectable
  );
  workInfoCostCenterValue$ = this.select((state) => state.workInfo?.costCenter?.costCenter?.id
      ? state.workInfo?.costCenter?.costCenter?.number +
          ' - ' +
          state.workInfo?.costCenter?.costCenter?.name
      : '');

  workInfoAbsence$ = this.select((state) => state.workInfo?.absence);
  workInfoAbsenceSelectable$ = this.select(
    (state) => state.workInfo?.absence?.selectable
  );
  workInfoAbsenceValue$ = this.select((state) => state?.workInfo?.absence?.absence?.absenceNr
      ? state.workInfo?.absence?.absence?.absenceNr +
          ' ' +
          state.workInfo?.absence?.absence?.name
      : '');

  currentNote$ = this.select((state) => state.workInfo.currentNote);

  constructor(protected store: WorkInfoStore) {
    super(store);
  }
}
